const CUSTOM_LABEL_CLIENT_IDS = ['132953', '44631', '130630']
//130630 - PMY-KH26-0284
const CUSTOM_LABELS = {
	'Ghi chú đặc biệt': 'Lý do gửi',
	'Đại diện gửi': 'Người YC gửi',
}

export const isSpecialClient = (clientID) => CUSTOM_LABEL_CLIENT_IDS.includes(String(clientID))

export const getClientRequiredRules = (clientID, text) =>
	(isSpecialClient(clientID) || clientID == 130630)
		? [{ required: true, whitespace: true, message: `Vui lòng nhập ${getClientLabel(clientID, text)}` }]
		: []

// Accept numeric or string client IDs; keep the original text for other clients.
export const getClientLabel = (clientID, text) => {
	if (!isSpecialClient(clientID)) return text

	return Object.prototype.hasOwnProperty.call(CUSTOM_LABELS, text) ? CUSTOM_LABELS[text] : text
}

export const getOrderContentField = (clientID, defaultPlaceholder) => ({
	label: String(clientID) === '132953' ? 'Loại hàng hóa' : 'Nội dung',
	placeholder: String(clientID) === '132953' ? 'Tên BCNB_Tên hàng hóa' : defaultPlaceholder,
})
